import React, {useEffect} from 'react'
import _ from 'lodash'
import {MapContainer, TileLayer, Marker, useMap, useMapEvent} from 'react-leaflet'

const MapHandler = ({coords, onClick}) => {
  const map = useMap()

  useMapEvent('click', ({latlng}) => onClick && onClick(latlng))

  useEffect(() => !_.isEmpty(coords) && map.setView(coords), [coords])

  return _.isEmpty(coords) ? null : <Marker position={coords} />
}

// MAPBOX - for satellite tiles
const OPENSTREETMAP_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
const LINZ_ATTRIBUTION =
  '&copy; <a href="https://www.linz.govt.nz/products-services/data/licensing-and-using-data/attributing-elevation-or-aerial-imagery-data">Sourced from LINZ. CC BY 4.0</a>'

export default ({height = '66vh', coords = [], className, onClick}) => {
  const zoom = _.isEmpty(coords) ? 5 : 18
  const centre = _.isEmpty(coords) ? [-41.24599927763154, 174.13083667283595] : coords
  return (
    <div className={`map-container ${className}`} style={{height}}>
      <MapContainer center={centre} zoom={zoom} style={{height: '100%'}}>
        <TileLayer attribution={OPENSTREETMAP_ATTRIBUTION} url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' />
        <TileLayer
          attribution={LINZ_ATTRIBUTION}
          minZoom={14}
          url='https://tiles-cdn.koordinates.com/services;key=4b4f3d5654124a399cf48cef4280aa63/tiles/v4/layer=95552/EPSG:3857/{z}/{x}/{y}.png'
        />
        <TileLayer
          attribution={LINZ_ATTRIBUTION}
          minZoom={14}
          url='https://tiles-cdn.koordinates.com/services;key=4b4f3d5654124a399cf48cef4280aa63/tiles/v4/layer=122168
/EPSG:3857/{z}/{x}/{y}.png'
        />
        <TileLayer
          attribution={LINZ_ATTRIBUTION}
          minZoom={14}
          url='https://tiles-cdn.koordinates.com/services;key=4b4f3d5654124a399cf48cef4280aa63/tiles/v4/layer=51928/EPSG:3857/{z}/{x}/{y}.png'
        />
        <MapHandler coords={coords} onClick={onClick} />
      </MapContainer>
    </div>
  )
}
